// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MgVCf","controls":"styles_controls__1xwUx","charLimit":"styles_charLimit__3lO4P","input":"styles_input__OPcEm","send":"styles_send__10ic9"};